/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var DataChartPieA1Icon16Solid = forwardRef('DataChartPieA1Icon16Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 16 }, props),
        React.createElement("path", { d: "M8 1a7 7 0 1 0 6.216 3.777L8.75 7.933A.5.5 0 0 1 8 7.5V1Z" }),
        React.createElement("path", { d: "M9 1.07a6.997 6.997 0 0 1 4.692 2.855L9 6.634V1.071Z" })));
});
